import {Button, Icon, LabelRegular} from '@hm/fundamental'
import {mdiAlertCircleOutline, mdiChevronDown} from '@mdi/js'

type SelectButtonProps = {
  label?: string
  onClick?: React.MouseEventHandler<HTMLElement>
  isDropdownOpen: boolean
  inputLabel: string
  emptyLabel?: string
  isReadOnly?: boolean
  error?: string
  disabled?: boolean
  dataTestId?: string
  showSearch?: boolean
  searchInputRef: React.RefObject<HTMLInputElement>
  listWrapperRef?: React.RefObject<HTMLDivElement>
}

export const SelectButton = ({
  dataTestId,
  disabled,
  emptyLabel,
  error,
  inputLabel,
  isDropdownOpen,
  isReadOnly,
  label,
  onClick,
  searchInputRef,
  showSearch,
  listWrapperRef
}: SelectButtonProps) => (
  <Button
    onClick={(event) => {
      onClick?.(event)
      if (showSearch && searchInputRef.current) {
        setTimeout(() => searchInputRef.current?.focus(), 0)
      } else if (!showSearch && listWrapperRef?.current) {
        setTimeout(() => listWrapperRef.current?.focus(), 0)
      }
    }}
    className={`flex !justify-start w-full py-1 px-3 h-[48px] ${isReadOnly && 'border-none'} ${
      error && 'border-negative'
    } relative`}
    toggled={isDropdownOpen}
    variant="secondary"
    disabled={disabled}
    data-cy={dataTestId}
    type="button"
  >
    <div className="flex justify-between items-center w-full py-1">
      <div className="flex flex-col items-start">
        <LabelRegular className="text-foreground_faded">{inputLabel}</LabelRegular>
        {label || emptyLabel}
      </div>
      {!isReadOnly && (
        <Icon
          className={error && 'text-negative'}
          path={error ? mdiAlertCircleOutline : mdiChevronDown}
        />
      )}
    </div>
  </Button>
)
